var burger = document.getElementsByClassName("burger");
var menu = document.getElementsByClassName("menu-mobile-pop");
burger[0].addEventListener("click", () => {menu[0].classList.toggle("menu-open"), burger[0].classList.toggle("open")});